import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import './tags.css'
const InvoiceModuleRenew = ({
  data,
  handleValue,
  getTag,
  getTagById,
  prefilledData,
  invoiceAmtData,
  isdisable=false,
  productData=null
}) => {
  const {
   commercialData,
   products
  } = data;
  console.log('PAGE::RENEW INVOICE MODULE');
  const [inputList, setInputList] = useState([{ product:"",description: "", sub_amount: "", qty:1}]);
  const [invoiceData, setInvoiceData] = useState();
  const [invoiceAmt, setInvoiceAmt] = useState([]);
  const [isTarget, setIsTarget] = useState('');
  const [invoiceDay, setInvoiceDat] = useState(0);
  
  useEffect(() => {
   
    if (
      prefilledData?.invoice_module !== undefined &&
      prefilledData?.invoice_module !== null
    ) {
      const tagData = prefilledData?.invoice_module;
      
      setTimeout(() => {
        if (tagData != '') {
          setInputList(tagData);
        }
      }, 100);

    }
    if (
      prefilledData?.commercial?.pre_invoice_day !== undefined &&
      prefilledData?.commercial?.pre_invoice_day !== null
    ) {
      const pre_invoice_day = prefilledData?.commercial?.pre_invoice_day;
      setInvoiceDat(pre_invoice_day);
      

    }
  }, [prefilledData]);
  
  useEffect(() => {
    if (
      invoiceAmtData?.invoice_amt !== undefined &&
      invoiceAmtData?.invoice_amt !== null
    ) {
      const invAmts = invoiceAmtData?.invoice_amt;
      
      setTimeout(() => {
        if (invAmts != '') {
          setInvoiceAmt(invAmts);
        }
      }, 50);

    }
  }, [invoiceAmtData]);
  //console.log('inv data ' + invoiceAmtData);

      // handle input change
    const handleInputChange = (e, index,inputName) => {
      if(inputName==='sub_amount'){
        const invAmt = [...invoiceAmt];
        invAmt[index] = Number(e);
        setInvoiceAmt(invAmt);
      }
      // console.log(e); return false;
      // const { name, value } = e.target;
      const list = [...inputList];
      list[index][inputName] = e;
      setInputList(list);
    };
    const handledropDownChange = (e, index,name) => {
      const { value,id} = e;
      const list = [...inputList];
      list[index][name] = id;
      list[index]['description'] = value;
      setInputList(list);
    };
    
    // handle click event of the Remove button
    const handleRemoveClick = index => {

      const amtList = [...invoiceAmt];
      amtList.splice(index,1);
      setInvoiceAmt(amtList);

      const list = [...inputList];
      list.splice(index, 1);
      setInputList(list);
    };
    // handle click event of the Add button
    const handleAddClick = () => {
      setInputList([...inputList, {product:"",description: "", sub_amount: "",qty:1 }]);
    };
    const handleFormData = () => {
      if (inputList) {
        handleValue({
          invoiceData: inputList,
          invoiceAmt:invoiceAmt,
          invoiceDay:invoiceDay,
        });
      } else {
        handleValue(null);
      }
    };
  
    useEffect(() => {
      handleFormData();
    }, [inputList]);
    useEffect(() => {
      handleFormData();
    }, [invoiceDay]);

  return (
    <Fragment>
      <FormSection title={localization.invoiceModule}>
        <>
        {commercialData && commercialData.subscription_amount ?
          <><h4>Subscription Amount : <small>{commercialData.subscription_amount}</small></h4></>
          :""}
          {/* {isdisable === false ? 
          <ConstantInput
          label={`Invoice Day (For Mid month Invoicing)`}
          type="number"
          value={invoiceDay}
          handleChange={(e) =>
            {
              setInvoiceDat(e)
            }
            }
          min={0}
          disabled={isdisable}

        />

          : null}  */}
          
        </>
      
      {inputList.map((x, i) => {
      return (
        <div key={i} className="row" >
          <div className="col-3">
          <DropDownInput
          data={productData}
          label={localization.product}
          // required
          // isStarRequired={true}
          errorMsg={localization.product}
          getIdValue={(val) =>{
            setInvoiceData({
              ...invoiceData,
              product: val.id,
            });
            handledropDownChange(val,i,'product');
          }
          }
          disabled={isdisable}
          value={x.name}
          // onChange={e => handleInputChange(e, i)}
        />
 
          </div>

          <div className="col-3">
                <ConstantInput
                    label={localization.sub_amount}
                    type="number"
                    value={x.sub_amount}
                    handleChange={(e) => 
                      {
                        handleInputChange(e, i,'sub_amount')
                      }
                      }
                    // required
                    // isStarRequired={true}
                    min={0}
                    // disabled={isdisable}

                  />
      
           </div>
          
           <div className="col-4">
           <ConstantInput
                  label={localization.description}
                  type="text"
                  value={x.description}
                  handleChange={(e) => 
                    {
                      handleInputChange(e, i,'description')
                    }
                    }
                  // required
                  // isStarRequired={true}
                  min={0}
                  disabled={true}

                />
          
           </div>

          <div className="col-4">
            <ConstantInput
                label={localization.quantity}
                type="number"
                value={x.qty}
                handleChange={(e) =>
                {
                  handleInputChange(e, i,'qty')
                }
                }
                // required
                // isStarRequired={true}
                min={0}
                disabled={isdisable}

            />

          </div>
          
          {/* <div className='col-3'> */}
            <div className='col-1'>
              {inputList.length !== 1 && <button
                onClick={() => handleRemoveClick(i)} className="btn btn-sm btn-danger">Remove</button>}
            </div>
            <div className='col-1'>
              {inputList.length - 1 === i && <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>}
            </div>
             
          {/* </div> */}
          <div className="btn-box">
           
          </div>

        </div>
      );
    })} 
        {/* <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div> */}
      
      </FormSection>
      
    </Fragment>
  );
};
InvoiceModuleRenew.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default InvoiceModuleRenew;
